/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  UpdateHardwarePreferencesRequest,
} from '../models/index';
import {
    UpdateHardwarePreferencesRequestFromJSON,
    UpdateHardwarePreferencesRequestToJSON,
} from '../models/index';

export interface UpdateHardwarePreferencesOperationRequest {
    deviceId: string;
    updateHardwarePreferencesRequest?: UpdateHardwarePreferencesRequest;
}

/**
 * 
 */
export class DevicesApi extends runtime.BaseAPI {

    /**
     */
    async updateHardwarePreferencesRaw(requestParameters: UpdateHardwarePreferencesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling updateHardwarePreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/devices/hardware-preferences/{deviceId}`.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters['deviceId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateHardwarePreferencesRequestToJSON(requestParameters['updateHardwarePreferencesRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateHardwarePreferences(requestParameters: UpdateHardwarePreferencesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateHardwarePreferencesRaw(requestParameters, initOverrides);
    }

}
